// autogenerated
import {AthenaeumConstants, ServiceProvider} from "@reapptor-apps/reapptor-toolkit";
import {ETagRequest} from "@reapptor-apps/reapptor-react-common";

export default class ListBookingBoatsRequest extends ETagRequest {

    public bookingId: string = "";

    public readonly isListBookingBoatsRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof ListBookingBoatsRequest) || ((from as any).isListBookingBoatsRequest === true));
    }

    public static as(from?: object | null): ListBookingBoatsRequest | null {
        return (ListBookingBoatsRequest.is(from)) ? from as ListBookingBoatsRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(ListBookingBoatsRequest, "ListBookingBoatsRequest");